<template>
	<FilterComponent
		:title="'Planos'"
		:open="openFilter"
		:fields="filterFields"
		@apply-filters="handleFilters"
		@update-open="openFilter = false"
    />
	<Commonlisting
		:listingData = "data"
		:headersData = "headers"
		:headerInfo = "headerInfo"
		:inputsListing= "inputs"
		:previous = "previous"
		:next = "next"
		:currentPage = "currentPage"
		:totalPages = "totalPages"
		:totalRecords = "totalRecords"
		:resetFormData= "resetFormData"
		:editFormData= "editFormData"
		:importFile= "false"
		:useForms= "true"
		:fileOnly= "false"
		:customActions="[
			{ 	nome: 'Importar',
				field: 'empresa_id'
			},
		]"
		@previous-page= "pageData"
		@next-page= "pageData"
		@go-to-page= "goTo"
		@find-by-field= "filtered"
		@clean-filter= "cleanFilter"
		@send-form-data= "onSendFormData"
		@delete-data-id= "deleteData"
		@edit-confirmation= "getEditData"
		@send-editing-data= "onSendEditingData"
		@view-confirmation= "getEditData"
		@filter="openFilter = true"
	/>
	<CommonLoading
		v-if="loading"
	/>
</template>
<script>
import Commonlisting from '@/components/generalcomponents/CommonListing';
import PlanosRepository from '@/services/PlanosRepository.vue';
import { pageVariables } from '@/views/insideviews/planos/PageVariablesPlanos';
import { handleUnauthorized } from '@/services/AuthSer/authServiceFunction';
import FilterComponent from "@/components/generalcomponents/CommonFilter.vue";
import Swal from "sweetalert2";
import CommonLoading from '@/components/generalcomponents/CommonLoading.vue';

export default {
	name: 'PlanosView',
	async created(){
		this.onlineUser = JSON.parse(window.localStorage.getItem("myUser") || "{}");
		this.pageData(this.planosFilterPage)
	},
	data() {
		return {
			...pageVariables,
			data: [],
			previous: '',
			next: '',
			totalPages: 0,
			totalRecords: 0,
			currentPage: 0,
			resetFormData: false,
			editFormData:{},
			openFilter: false,
			filters: [],
			filterFields: [
				{
					name: "nome",
					label: "Nome",
					type: "input",
					placeholder: "Digite o nome do plano"
				},
				{
					name: "valor",
					label: "Valor",
					type: "input",
					placeholder: "Digite o valor do plano"
				},
				{
					name: "regra_de_faturamento",
					label: "Regra de Faturamento",
					type: "input",
					placeholder: "Digite a Regra de faturamento do plano"
				},
				{
					name: "empresa",
					label: "Empresa Relacionada",
					type: "input",
					placeholder: "Digite a empresa relacionada ao plano"
				},
			],
			onlineUser: JSON.parse(window.localStorage.getItem("myUser"))
		};
	},
	props: {
	},
	methods: {
		async pageData(page){
			this.loading = true; 
			const planoRepo = new PlanosRepository();
			try {
				const response = await planoRepo.getPlanos(this.onlineUser.token,page,this.filters);
				if (response?.status  === 200) {
					this.data = response.data.data;
					this.totalPages = response.data.last_page;
					this.totalRecords = response.data.total;
					this.currentPage = response.data.current_page;

				if (response.data.next_page_url) {
					this.next = response.data.next_page_url;
				}else{
					this.next = ""
				}
				if (response.data.prev_page_url) {

					this.previous = response.data.prev_page_url;
				}else{
					this.previous = ""
				}
				this.loading = false; 

				}
			} catch (error) {
				this.loading = false;
				this.mostrarAlertaErro(error);
				handleUnauthorized(error); 
			}
		},
		async onSendFormData(data){
			this.loading = true; 
			const planoRepo = new PlanosRepository();
			try {
				const response = await planoRepo.createPlano(this.page,data,this.onlineUser.token);
				if (response?.status === 201) {
					this.pageData(this.planosFilterPage);
					this.resetForm();
					this.mostrarAlerta();
					this.loading = false; 
				} else {
					this.error = response?.message;
					this.mostrarAlertaErro(this.error);
					this.loading = false;
				}
			} catch (error) {
				this.loading = false;
				this.mostrarAlertaErro(error);
				handleUnauthorized(error);
			}	
		},
		async onSendEditingData(data,id){
			this.loading = true; 
			const planoRepo = new PlanosRepository();
			try {
				const response = await planoRepo.updatePlano(this.page,this.onlineUser.token,id,data);
				if (response?.status === 200) {
					this.pageData(this.planosFilterPage);
					this.mostrarAlerta();
					this.loading = false; 
				} else {
					this.loading = false; 
					this.error = response?.message;
					this.mostrarAlertaErro(this.error);
				}
			} catch (error) {
				this.loading = false; 
				this.mostrarAlertaErro(error);
				handleUnauthorized(error);
			}	
		},
		async deleteData(id){
			this.loading = true; 
			const planoRepo = new PlanosRepository();
			try {
				const response = await planoRepo.deletePlano(this.page,this.onlineUser.token,id);
				if (response?.status === 204) {
					this.loading = false; 
					this.mostrarAlerta();
					this.pageData(this.planosFilterPage);

				} else {
					this.loading = false; 
					this.error = response?.message;
					this.mostrarAlertaErro(this.error);
				}
			} catch (error) {
				this.loading = false; 
				handleUnauthorized(error);
				this.mostrarAlertaErro(error);
			}	
		},
		async getEditData(id){
			this.loading = true; 
			const planoRepo = new PlanosRepository();
			try {
				const response = await planoRepo.getPlano(this.page,this.onlineUser.token,id);
				if (response?.status === 200) {
					this.editFormData = response.data
					this.loading = false; 
				} else {
					this.error = response?.message;
					this.loading = false; 
					this.mostrarAlertaErro(this.error);
				}
			} catch (error) {
				this.loading = false; 
				this.mostrarAlertaErro(error);
				handleUnauthorized(error);
			}	
		},
		goTo(number){
			this.pageData(this.planosFilterPage+"?page="+number)
		},
		filtered(filteredData){
			const key = this.seachFilterKey;
			const value = filteredData;
			if (key) {
				this.pageData(this.planosFilterPage+"?"+key+'='+value);
			}
		},
		cleanFilter(){
			this.pageData(this.planosFilterPage)	
		},
		
		resetForm() {
			this.resetFormData = true;
			this.$nextTick(() => {
				this.resetFormData = false;
			});
		},

		handleFilters(rawFilters){
			console.log(rawFilters)
			this.filters = rawFilters;
			this.openFilter = false;
			this.pageData(this.planosFilterPage);
		},

		mostrarAlerta() {
			Swal.fire({
				icon: 'success',
				title: 'Sucesso!',
				text: 'A operação foi concluída com sucesso.',
				confirmButtonColor: '#3085d6', 
			});
		},

		mostrarAlertaErro(message) {
			Swal.fire({
				icon: 'error',
				title: 'Erro!',
				text: message,
				confirmButtonColor: '#3085d6', 
			});
		},
	},
	components:{
		Commonlisting,
		FilterComponent,
		CommonLoading
	},
	setup() {
	return {
	}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
